import { Api } from '@/api/api'
import { EmptyProject } from '@/business/project/interfaces/project-view-model'
import { ProjectRequest, ProjectResponse } from '@/api/generated'

export class ProjectService {
  createProject(project: ProjectRequest): Promise<ProjectResponse> {
    return Api.Projects.createProject({
      projectRequest: project,
    })
  }

  getOfferReport(offerId: number): Promise<ProjectResponse> {
    return Api.Offers.getOfferReport({
      offerId,
    }).catch(() => this.getProjectStub(offerId))
  }

  updateProject(project: ProjectRequest, projectId: number): Promise<ProjectResponse> {
    return Api.Projects.updateProject({
      projectId,
      projectRequest: project,
    })
  }

  private getProjectStub(offerId: number): Promise<ProjectResponse> {
    return Api.Offers.getOffer({
      offerId,
    }).then(offer => {
      return {
        ...EmptyProject,
        categories: offer.categories,
        name: offer.name,
        offer,
        partners: [offer.organisation]
          .concat(offer.partners.map(partner => partner.organisation))
          .map(organisation => {
            return {
              organisation,
              testimonial: '',
            }
          }),
        resources: offer.resources.filter(resource => resource.name === 'logo'),
        shortDescription: '',
      }
    })
  }
}
